import React from 'react';
import { Mic } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-ink py-12 md:py-14 px-4 md:px-6 text-center" data-id="element-38">
      <div className="max-w-3xl mx-auto" data-id="element-39">
        <div className="inline-flex items-center gap-2 text-white/70 font-semibold text-[12px] md:text-[13px] tracking-[0.12em] uppercase mb-4" data-id="element-40">
          <Mic className="w-4 h-4" strokeWidth={2} data-id="element-41" />
          Tu Manual Digital
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mb-5" data-id="element-42">
          <a href="https://tumanualdigital.com" target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-brand-gold text-[12px] transition-colors" data-id="element-43">
            tumanualdigital.com
          </a>
          <a href="mailto:soporte.tumanualdigital@gmail.com" className="text-white/40 hover:text-brand-gold text-[12px] transition-colors" data-id="element-44">
            soporte.tumanualdigital@gmail.com
          </a>
          <a href="https://instagram.com/tu.manualdigital" target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-brand-gold text-[12px] transition-colors" data-id="element-45">
            @tu.manualdigital
          </a>
        </div>

        <p className="text-white/25 text-[11px] leading-[1.8] max-w-xl mx-auto" data-id="element-46">
          Este material es de uso profesional exclusivo del comprador. Prohibida
          su reproducción o reventa sin autorización escrita de Tu Manual
          Digital.
          <br data-id="element-47" />© 2026 Tu Manual Digital. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}